import { Text, Link } from '@primerai/thread';
import { useDispatch } from 'react-redux';
import { Link as RouterLink } from 'wouter';
import { FORGOT_PASSWORD } from '~/routes/paths';
import { Actions } from '~/store/password/actions';

const ForgotPasswordLink = () => {
  const dispatch = useDispatch();
  const onClick = () => dispatch(Actions.FORGOT_PASSWORD_RESET());

  return (
    <Text as="p" mt="$7" textAlign="right">
      <Link as={RouterLink} onClick={onClick} to={FORGOT_PASSWORD}>
        Forgot your password?
      </Link>
    </Text>
  );
};

export default ForgotPasswordLink;
